import "web/entrypoints/common/polyfills";

import { setup } from "web/entrypoints/common/setup";
import "./baustein-main";
import { components } from "./react-main";

setup(components);
